"use strict";

import classNames from "classnames";
import React, {createRef} from "react";

import Button from "@/components/button/Button.tsx";
import {Input} from "@/components/input/Input.tsx";
import {FieldErrors, FieldHelpText, Label, uniqueHtmlId, unpackFormLinkOrProps} from "@/legacy/form/FormHelpers.jsx";

export default class TextInput extends React.Component {
  constructor(props) {
    super(props);
    this.htmlId = uniqueHtmlId(props.fieldName);
    this.textInput = createRef();
  }

  focus() {
    this.textInput.current.focus();
  }

  render() {
    const form = unpackFormLinkOrProps(this.props);

    return (
      <div className="form-group">
        <Label fieldId={this.htmlId} {...this.props} wizard={undefined} />
        {this.props.addonLabel || this.props.addonPrefix ? this.renderInputGroup(form) : this.renderInput(form)}
        <FieldErrors errors={form.errors} />
        <FieldHelpText {...this.props} />
      </div>
    );
  }

  renderInputGroup(form) {
    return (
      <div className={classNames("d-flex gap-3 align-items-center", this.props.inputGroupClass)}>
        {this.props.addonPrefix && <span className="pulseTextBodySmall">{this.props.addonPrefix}</span>}
        {this.renderInput(form)}
        {this.props.addonLabel && (
          <Button variant="secondary" onClick={this.props.onAddonClick} className="text-nowrap">
            {this.props.addonLabel}
          </Button>
        )}
      </div>
    );
  }

  renderInput(form) {
    return (
      <Input
        ref={this.textInput}
        type={this.props.inputType}
        data-wizard={this.props.wizard}
        id={this.htmlId}
        name={form.fieldName}
        className={classNames(this.props.extraInputCSS, {["is-invalid"]: form.errors})}
        disabled={this.props.disabled}
        maxLength={this.props.maxLength}
        readOnly={this.props.readOnly}
        placeholder={this.props.placeholder}
        value={form.value}
        onChange={form.onChange}
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
      />
    );
  }
}

TextInput.defaultProps = {
  fieldName: null, // Field name returned in form data
  labelText: null, // Label of this field
  titleText: null, // Tooltip
  helpText: null, // Help text beneath the field
  placeholder: null, // Placeholder text
  isRequired: false, // Field is required?
  readOnly: false, // Field is read-only?
  disabled: false, // Control is disabled?
  inputType: "text", // Type of input
  maxLength: null, // HTML maxlength for this field
  addonPrefix: null, // Text/HTML to place in the addon on the left of the field
  addonLabel: null, // Label for an addon button at the end of the field
  inputGroupClass: "", //Additional class to append to input group
  wizard: undefined, // Set a data-wizard attribute on the text field

  formLink: null, // Object from prepareFormLink() to auto-bind value, onChange, formErrors
  value: null, // React field value
  formErrors: null, // Dict of all form errors, possibly with an entry for fieldName

  onChange: null, // Change handler
  onAddonClick: null, // Handler when addon button is clicked
  onFocus: null, // Focus handler
  onBlur: null, // Blur handler

  extraInputCSS: null, // Extra CSS class to pass to <input>
};
